import clsx from "clsx";
import { Checkbox } from "react-aria-components";

export interface HdCheckBoxProps {
  className?: string;
  labelClassName?: string;
  label?: string;
  name?: string;
  checked?: boolean;
  disabled?: boolean;
  onChange?: (value: boolean) => void;
  checkBefore?: boolean;
}

function HdCheckBox({
  checked,
  name,
  disabled,
  onChange,
  className,
  labelClassName,
  label,
  checkBefore = false,
}: HdCheckBoxProps) {
  return (
    <Checkbox
      aria-label="checkbox"
      isSelected={checked}
      onChange={onChange}
      isDisabled={disabled}
      name={name}
      className={clsx(
        "group flex items-center gap-1",
        !disabled && "cursor-pointer"
      )}
    >
      {label && <span className={labelClassName}>{label}</span>}
      <div
        className={clsx(
          className,
          "block size-4 border border-gray-300 bg-white group-data-[selected]:bg-primary flex-shrink-0",
          checkBefore ? "order-first" : "order-last"
        )}
      >
        <svg
          className="stroke-white opacity-0 group-data-[selected]:opacity-100"
          viewBox="0 0 14 14"
          fill="none"
        >
          <path
            d="M3 8L6 11L11 3.5"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
    </Checkbox>
  );
}

export default HdCheckBox;
